// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2IdLd","buttons":"RemoveExpirationActionButtons_buttons__2K5IF"};